export default __webpack_public_path__ + "static/media/cvv-expl.358f4c6e.png";